import { MapPin, Lightbulb } from "lucide-react";
import { eur } from "@/lib/api";

export const Itinerary = ({ days = [] }) => (
  <div data-testid="premium-itinerary" className="space-y-10">
    {days.map((d) => (
      <section key={d.day} data-testid={`itinerary-day-${d.day}`}>
        <div className="flex items-baseline gap-3 border-b border-gray-200 pb-3">
          <span className="font-mono text-xs uppercase tracking-widest text-amber-600">Jour {d.day}</span>
          <h3 className="font-serif text-2xl font-semibold text-[#0B131E]">{d.title}</h3>
        </div>
        <ol className="mt-6 relative border-l border-amber-200 ml-2 space-y-7">
          {(d.steps || []).map((s, i) => (
            <li key={i} className="pl-6 relative">
              <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-amber-600" />
              <div className="flex flex-wrap items-baseline gap-x-3">
                <span className="font-mono text-sm text-amber-700">{s.time}</span>
                <h4 className="font-semibold text-gray-900">{s.title}</h4>
                {s.cost ? <span className="text-xs text-gray-500">{eur(s.cost)}</span> : null}
              </div>
              <p className="mt-1 text-sm text-gray-600 leading-relaxed">{s.description}</p>
              {s.location ? <p className="mt-1 flex items-center gap-1 text-xs text-gray-500"><MapPin className="w-3 h-3" />{s.location}</p> : null}
              {s.tip ? <p className="mt-2 flex gap-1.5 text-xs text-emerald-800 bg-emerald-50 rounded-lg px-3 py-2"><Lightbulb className="w-3.5 h-3.5 shrink-0 mt-px" />{s.tip}</p> : null}
            </li>
          ))}
        </ol>
      </section>
    ))}
  </div>
);
